// extracted by mini-css-extract-plugin
export default {"custom_dot_list_style":"SellDisplay_custom_dot_list_style__AJuTg"};